import * as Yup from 'yup';
import getMaximumDecimalSchema from './getMaximumDecimalSchema';

export function getNullableIntegerSchema(fieldName: string) {
  return Yup.number()
    .nullable()
    .integer(`${fieldName} must not be decimal.`)
    .max(2147483647, `${fieldName} cannot exceed 2,147,483,647.`)
}

export default function getNumberSchema(
  customMessage: string,
  moreThanNumber: number = 0,
  maxDecimalPlaces: number = 2
) {
  return Yup.number()
    .concat(getMaximumDecimalSchema(maxDecimalPlaces))
    .typeError("Please enter a valid number")
    .required(`${customMessage} is required.`)
    .moreThan(moreThanNumber, `${customMessage} must be greater than $${moreThanNumber}.`);
}
